




















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { trim, dateFormat } from "@/util";
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import { SzgcProcessGetor, SzgcMobileGetor } from "@/index";

@Component({
  name: "WbenchTodoAll",
  components: {
    SzgcProcessGetor,
    SzgcMobileGetor
  }
})
export default class WbenchTodoAll extends Vue {
  @Prop({
    type: String,
    default: "web"
  })
  private client!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessName: any = "";
  private total: number = 0;
  private params: any = {
    current: 1,
    pageSize: 20
  };
  private tableData: any = [];
  private processShow: boolean = false;
  private processData: any = null;
  private businessId: string | number = "";
  private page: string = "todo";
  private prefix: string = "";

  mounted() {
    this.prefix = getCookie("plt-api-route") || "";
    this.getTableData();
  }

  /*获取表格数据*/
  async getTableData() {
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getTodoAll,
        method: "post",
        data: {
          clientType: "web",
          todoTitle: trim(this.businessName),
          current: this.params.current,
          pageSize: this.params.pageSize,
          clientTypeOnly: true
        }
      });
      if (!success) {
        this.$message.error("获取待办列表失败:" + message);
        return false;
      }
      const temp: any = [];
      if (data && data.records && data.records.length > 0) {
        data.records.map((item: any) => {
          item.createTime = item.createTime ? dateFormat(item.createTime) : "--";
          item.claimTime = item.claimTime ? dateFormat(item.claimTime) : "--";
          temp.push(item);
        });
        this.total = data.total;
      }
      this.tableData = temp;
      this.$emit("getTotal");
    } catch (error: any) {
      this.$message.error("获取待办列表失败:" + error);
    }
  }

  /*展示流程详情*/
  processModal(data: any) {
    if (!data.dialogEnable) {
      return this.$message.info("请在APP端查看和操作该事项");
    }
    this.page = data.type;
    if (this.page === "todo") {
      this.processData = {
        status: data.statusCode,
        businessId: data.businessId,
        taskId: data.procTaskId
      };
    } else {
      this.processData = {
        businessId: data.businessId
      };
    }
    this.processShow = true;
  }

  /*关闭流程详情*/
  closeProcess(data: any) {
    if (this.page === "todo") {
      if (data.type === "close") {
        this.processShow = false;
      }
      this.getTableData();
    } else {
      this.processShow = false;
      this.getTableData();
    }
  }

  /*搜索*/
  searchEvt() {
    this.params.current = 1;
    this.params.businessId = "";
    this.getTableData();
  }

  /*页数改变*/
  onCurrentChange(val: any) {
    this.params.current = val;
    this.getTableData();
  }

  /*size改变*/
  onSizeChange(val: any) {
    this.params.current = 1;
    this.params.pageSize = val;
    this.getTableData();
  }
}
